var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Transform } from 'class-transformer';
import moment from 'moment';
class AuthorizedAccounts {
    accountId;
    accountName;
}
export class TracingAccountModel {
    accountId;
    accountName;
    plan;
    createdAt;
    token;
    isSearchable;
    authorizedAccounts;
    suspensionState;
    tracingAccountSettings;
}
__decorate([
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    Transform(value => value?.valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], TracingAccountModel.prototype, "createdAt", void 0);
//# sourceMappingURL=tracing-account.js.map